import ChevronUpIcon from '@heroicons/react/outline/esm/ChevronUpIcon.js'
import ThumbUpIcon from '@heroicons/react/solid/esm/ThumbUpIcon.js'
import { clsx } from 'clsx'

import {
  PostReactionDetail,
  ReactionType,
} from '@tribeplatform/gql-client/types'

import { IconEmoji } from '../common/components/IconEmoji.js'

export const Reaction = ({
  reaction,
  reactionType,
  onClick,
  label,
}: {
  reaction: PostReactionDetail
  reactionType: ReactionType
  onClick?: (reaction: PostReactionDetail) => void
  label?: string
}) => {
  switch (reactionType) {
    case ReactionType.LIKE_BASE:
      return (
        <button
          type="button"
          className={clsx(
            'rounded-full flex items-center justify-center -me-2 p-1',
            reaction.reacted
              ? 'bg-action-primary hover:primary-focused'
              : 'bg-surface-pressed hover:bg-skeleton',
          )}
          onClick={() => {
            onClick?.(reaction)
          }}
          aria-label={label}
        >
          <ThumbUpIcon
            className={clsx('w-3 h-3', { 'text-white': reaction.reacted })}
          />
        </button>
      )
    case ReactionType.VOTE_BASE:
      return (
        <button
          type="button"
          className={clsx(
            'rounded-full flex items-center justify-center -me-2 p-1',
            reaction.reacted
              ? 'bg-action-primary hover:primary-focused'
              : 'bg-surface-pressed hover:bg-skeleton',
          )}
          onClick={() => {
            onClick?.(reaction)
          }}
          aria-label={label}
        >
          <ChevronUpIcon
            className={clsx('w-3 h-3', { 'text-white': reaction.reacted })}
          />
        </button>
      )
    case ReactionType.EMOJI_BASE:
    default:
      return (
        <button
          type="button"
          className={clsx(
            'rounded-full w-9 h-7 text-lg border-2 border-line-subdued -me-2 flex items-center justify-center overflow-hidden',
            'bg-surface-pressed hover:bg-skeleton',
          )}
          onClick={() => {
            onClick?.(reaction)
          }}
          aria-label={label}
        >
          <IconEmoji text={reaction.reaction} />
        </button>
      )
  }
}
